import { Button, Layout, theme } from 'antd';
import { useSideNavStore } from '../../store';
import React from 'react';
const { Header } = Layout;
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import Profile from './Profile';

const AppHeader = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const sideNav = useSideNavStore();

  return (
    <Header style={{ padding: 0, background: colorBgContainer, height: 60 }}>
      <div className={'px-2 flex justify-between items-center  w-full'}>
        <div className={'flex items-center'}>
          <Button
            type="text"
            icon={
              sideNav.isCollapse ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
            }
            onClick={() => sideNav.setCollapse(!sideNav.isCollapse)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <h5 className={'text-lg font-semibold'}>{sideNav.selectedPage}</h5>
        </div>
        <div className={'pr-4'}>
          <Profile />
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;
